import React, { useMemo, useState } from 'react'
import { motion } from 'motion/react'

import { EffectBackgroundProps, OrbData } from '../types'

export const OrbsEffect = React.memo(({ layerStyle, index, values }: EffectBackgroundProps) => {
  const effectColors = useMemo(() => values.effectColors || ['#6366f1', '#8b5cf6'], [values.effectColors])
  const effectSpeed = values.effectSpeed ?? 100
  const effectOpacity = values.effectOpacity ?? 100
  const effectBackgroundColor = values.effectBackgroundColor || '#000000'
  const opacityValue = effectOpacity / 100

  const blurAmount = 60
  const orbColor1 = effectColors[0] || '#6366f1'
  const orbColor2 = effectColors[1] || '#8b5cf6'

  const [orbs] = useState(() => {
    const orbCount = 5
    const newOrbs: Array<OrbData> = []
    for (let i = 0; i < orbCount; i++) {
      newOrbs.push({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: 150 + Math.random() * 200,
        duration: 15 + Math.random() * 10,
        delay: Math.random() * 5,
      })
    }
    return newOrbs
  })

  return (
    <div
      style={{
        position: 'absolute' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -index - 1,
        overflow: 'hidden',
        backgroundColor: effectBackgroundColor,
      }}
    >
      {orbs.map((orb, orbIndex) => (
        <motion.div
          key={orb.id}
          style={{
            position: 'absolute',
            width: `${orb.size}px`,
            height: `${orb.size}px`,
            background: `radial-gradient(circle, ${orbIndex % 2 === 0 ? orbColor1 : orbColor2}, transparent)`,
            filter: `blur(${blurAmount}px)`,
            opacity: opacityValue,
            borderRadius: '50%',
          }}
          initial={{
            x: `${orb.x}vw`,
            y: `${orb.y}vh`,
          }}
          animate={{
            x: [`${orb.x}vw`, `${(orb.x + 20) % 100}vw`, `${orb.x}vw`],
            y: [`${orb.y}vh`, `${(orb.y + 30) % 100}vh`, `${orb.y}vh`],
          }}
          transition={{
            duration: orb.duration * (100 / Math.max(effectSpeed, 1)),
            repeat: Infinity,
            ease: 'easeInOut',
            delay: orb.delay,
          }}
        />
      ))}
    </div>
  )
})
OrbsEffect.displayName = 'OrbsEffect'
